import { Injectable, inject } from '@angular/core';

import { RootState } from '@next/core-lib/app';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';

import * as cycleActions from '../store/actions/cycle.actions';

@Injectable({
  providedIn: 'root',
})
export class CyclesGuard {
  private store = inject<Store<RootState>>(Store);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {}

  canActivate(): Observable<boolean> {
    this.store.dispatch(cycleActions.loadData());
    return of(true);
  }
}
